module.exports = __webpack_public_path__ + "static/media/country_va.9fd2eb27.webp";